module.exports = __webpack_public_path__ + "static/gallery11-5d6a3509e27df76c1ae12077bd1770f1.jpg";